import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { apiHOCs } from "components";
import { compose, getContext, lifecycle, withState } from "recompose";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TicketsTable from "components/ui/TicketsTable";

const ActivePrivateChatsScreen = ({
  tickets,
  getTickets,
  putCloseTicket,
  router,
  user,
}) => {
  const activeTickets = useMemo(() => {
    return tickets.filter((ticket) => {
      return ticket.get('adminID') === user.get("id")
    })
  }, [tickets]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={1}
        style={{
          width: 800,
          marginBottom: 20,
          padding: 10,
        }}
      >
        <Typography
          variant="headline"
          component="h3"
          style={{
            textAlign: "center",
          }}
        >
          Active private chats
        </Typography>
      </Paper>
      <Paper
        elevation={1}
        style={{
          width: 1120,
        }}
      >
        <TicketsTable 
          rows={activeTickets.sort((t1, t2) => {
            return new Date(t2.get('createdAt')) - new Date(t1.get('createdAt'));
          })}
          assign={(id) => {
            router.history.push(`/chats/${id}`);
          }}
          close={(id) =>  putCloseTicket({
            id: id,
            successCallback: () => getTickets({closed: false})
          })}
          isActive
        />
      </Paper>
    </div>
  );
}

ActivePrivateChatsScreen.defaultProps = {
}

export default compose(
  apiHOCs.ChatApiHOC(),
  apiHOCs.AuthApiHOC(),
  
  lifecycle({
    componentDidMount() {
      this.props.getTickets({closed: false});
    },
  }),

  getContext({
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  })
)(ActivePrivateChatsScreen);